import React, { ReactNode } from 'react';
import Select from 'react-select';

interface SelectProps {
  label?: string;
  rounded?: number;
  border?: number;
  error?: string;
  options: { value: string | number; label: string }[];
  isDisabled?: boolean;
  value?: string | number | null;
  required?: boolean;
  onChange?: (value: string | number | null) => void;
  formatOptionLabel?: (data: any) => ReactNode;
}

export const MLSelect: React.FC<SelectProps> = ({
  label = 'Select an option',
  error,
  border,
  rounded,
  options,
  value,
  isDisabled = false,
  ...props
}) => {
  return (
    <div style={{ fontFamily: 'Poppins, sans-serif' }}>
      <label htmlFor="customSelect" className={`form-label ${error ? 'text-danger' : ''} mb-1`}>
        {label}
        {props.required && <span className="text-danger m-1">*</span>}
      </label>

      <Select
        {...props}
        id="customSelect"
        classNamePrefix="custom-select"
        options={options}
        isDisabled={isDisabled}
        value={isDisabled ? null : options.find(option => option.value === value) || null}
        onChange={selectedOption => props.onChange?.(selectedOption ? selectedOption.value : null)}
        placeholder="Select an option"
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor: error ? 'red' : base.borderColor,
            boxShadow: state.isFocused ? '0 0 0 2px rgba(95, 0, 204, 0.5)' : 'none',
            borderRadius: rounded ? `${rounded}px` : base.borderRadius,
            fontFamily: 'Poppins, sans-serif',
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#6A37D4' : state.isFocused ? '#b683e6' : base.backgroundColor,
            color: state.isSelected || state.isFocused ? 'white' : 'black',
            fontFamily: 'Poppins, sans-serif',
          }),
          singleValue: base => ({
            ...base,
            color: 'black',
            fontFamily: 'Poppins, sans-serif',
          }),
          menu: base => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />

      {error && <div className="text-danger w-100 d-block mt-1">{error}</div>}
    </div>
  );
};
